var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"form-control",on:{"change":_vm.change}},[_c('option',{attrs:{"value":""}}),_vm._v(" "),_vm._l((_vm.templatemails),function(item,index){return _c('option',{domProps:{"value":item._id,"selected":_vm.value==item._id}},[_vm._v(_vm._s(item.name))])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d5fa01e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fields/SelectTemplatemail.vue
// module id = null
// module chunks = 